<template>
  <Popup id="popup-login" :popup="popup" type="full">
    <button class="arrow-back" @click="close($router)">
      <img src="@/asset/icon/arrow-full-left-green.svg" alt=""> <span>{{ $t('common.back') }}</span>
    </button>
    <template #close>
      <button class="btn-close" @click="close($router)">
        <img src="@/asset/icon/x.svg" class="img-x" alt="">
      </button>
    </template>
    <div class="heading">
      <h1 v-html="$t('login.welcome_to_bitskins')" />
    </div>
    <div class="content">
      <button class="btn btn-primary btn-main" @click="steamLogin()">
        <span>{{ $t('login.sign_in_with_steam') }}</span> <img src="@/asset/icon/social/steam.svg" class="ml-15" alt="">
      </button>
      <p>
        {{ $t('common.click') }}
        <span class="text-cp cursor-pointer link-primary" @click="openPopup($router, POPUP.LoginWithEmail)">
          {{ $t('common.here') }}
        </span>
        {{ $t('login.to_login_via_email') }}
      </p>
    </div>
  </Popup>
</template>

<script setup>
import { steamLogin } from '@/hook/steam.js';
import { POPUP, Popup, closePopup, isPopupOpen, openPopup } from '@/hook/system/popup.js';
import { ROUTE, pushRoute } from '@/facade/router.js';

const popup = POPUP.Login;
const close = (router) => (isPopupOpen(router, popup) ? closePopup(router, popup) : pushRoute(ROUTE.home));
</script>
